import URL from './addressBookUrl'
import http from '@/utils/httpUtils'

export default {
  /** ******************** 考勤通讯录 **********************/
  // 获取标签统计
  async addressGetAccommodationTagStatistics(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_GET_TAG_STATISTICS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 准备部门树
  async addressPrepare(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_PREPARE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 创建选人组件沙盒
  async addressCreate(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_CREATE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取沙盒状态
  async addressGetStatus(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_GET_STSTUS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查树节点信息
  async addressGetNodes(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_GET_NODES, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 加部门筛选条件
  async addressSelectDepts(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_SELECT_GROUPS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 移除部门筛选条件
  async addressUnselectDepts(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_UNSELECT_GROUPS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 加已选学生
  async addressSelectStudents(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_SELECT_STUDENTS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 勾选
  async addressChangeSelections(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_CHANGE_SELECTIONS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 选中单个学生
  async addressSelectOneStudent(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_SELECT_ONE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 取消选中单个学生
  async addressUnselectOneStudent(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_UNSELECT_ONE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 移除已选学生
  async addressUnslectStudents(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_SELECT_UNSTUDENTS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 清除所有已选择
  async addressUnslectAll(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_CLEAR_ALL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询已选学生列表-有选项的班级列表
  async addressQuerySelectClasses(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_GET_CHECKED_CLASSES, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询已选学生列表-学生列表 废弃
  async addressQuerySelectStudents(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_GET_CHECKED_STUDENTS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查班级下的学生列表及选中状态
  async addressQueryClassStudents(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_GET_CLASSES_STUDENTS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 修改选项-按班级学生
  async addressChangeClassStudentSelections(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_CHANGE_STUDENTS_SELECTIONS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 修改选项-按部门
  async addressChangeDeptSelections(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_CHANGE_DEPTS_SELECTIONS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 搜索学生
  async addressSearchStudents(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_SEARCH_STUDENTS, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 提交预选项
  async addressCommitPreSelections(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_COMMIT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 取消预选项
  async addressRollbackPreSelections(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_ROLLBACK, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询沙盒变更概述
  async addressGetChangeSummary(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_CHANGE_SUMMARY, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 重置沙盒状态，当沙盒变更处理超时时，要调些接口
  async addressResetStatus(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SANDBOX_RESET, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /** ******************** 考勤通讯录 **********************/

  /** ******************** padbook **********************/
  /* 班级树 */
  // 通用班级树,修改选项-按部门
  squirrelClassTreeChangeSelection(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASSTREE_CHANGESELECTION, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 通用班级树,提交预选项
  squirrelClassTreeCommit(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASSTREE_COMMIT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 创建树,班牌绑定范围
  squirrelClassTreeCreate(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASSTREE_CREATE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询已选节点列表
  squirrelClassTreeGetSelectedNodes(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASSTREE_GET_SELECTNODES, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 通用班级树,取消预选项
  squirrelClassTreeRollback(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASSTREE_ROLLBACK, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 通用班级树,查子节点
  squirrelClassTreeSubNodes(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASSTREE_SUBNODE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 通用班级树,清空所有已选学生
  squirrelClassTreeUnselectAll(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASSTREE_UNSELECT_ALL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 通用班级树,批量取消预选项
  squirrelClassTreeBatchRollback(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASSTREE_BATCH_ROLLBACK, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 通用班级树,批量提交预选项
  squirrelClassTreeBatchCommit(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASSTREE_BATCH_COMMIT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 模糊匹配部门名字
  squirrelClassTreeSearch(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_CLASSTREE_SEARCH, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /** ******************** padbook **********************/
  /** ******************** MUI **********************/
  /**
   * 获取根部门
   */
  async fishnetGetRootDept() {
    return http.get(URL.API_FISHNET_GET_ROOT_DEPT)
  },
  /**
   * 获取子部门列表
   * @param Object postData
   */
  async fishnetGetsubDepts(postData) {
    return http.get(URL.API_FISHNET_GET_SUB_DEPTS, postData)
  },
  /**
   * 获取成员标签
   * @param Object postData
   */
  async fishnetGetMembersTags(postData) {
    return http.post(URL.API_FISHNET_GET_MEMBERS_TAGS, postData)
  },
  /**
   * 获取机构标签list
   * @param Object postData
   */
  async fishnetGetTagList(postData) {
    return http.get(URL.API_FISHNET_GET_TAG_LIST, postData)
  },
  /**
   * 获取部门成员列表
   * @param Object postData
   */
  async fishnetGetDeptMembers(postData) {
    return http.get(URL.API_FISHNET_GET_DEPT_MEMBERS, postData)
  },

  /** ******************** MUI **********************/
  /** ******************** 机构通讯录 **********************/
  // 创建沙盒
  createOrgSandBox(postData) {
    return http.post(URL.API_ORG_SANDBOX_CREATE, postData)
  },
  // 获取沙盒状态
  getOrgSandBoxStatus(postData) {
    return http.post(URL.API_ORG_SANDBOX_STATUS, postData)
  },
  // 重置沙盒
  resetOrgSandBox(postData) {
    return http.post(URL.API_ORG_SANDBOX_STATUS_RESET, postData)
  },
  // 获取已选人员
  getOrgSelectedUsers(postData) {
    return http.post(URL.API_ORG_SANDBOX_MEMBER_SELECT, postData)
  },
  // 查询子节点
  getOrgSubNodes(postData) {
    return http.post(URL.API_ORG_SANDBOX_SUBNODES, postData)
  },
  // 查询部门人员列表
  getOrgDeptUsers(postData) {
    return http.post(URL.API_ORG_SANDBOX_MEMBER, postData)
  },
  // 选择部门
  selectOrgDepts(postData) {
    return http.post(URL.API_ORG_SANDBOX_SELECT_DEPT, postData)
  },
  // 选择人员
  selectOrgUsers(postData) {
    return http.post(URL.API_ORG_SANDBOX_SELECT_MEMBER, postData)
  },
  // 取消选择部门
  unSelectOrgDepts(postData) {
    return http.post(URL.API_ORG_SANDBOX_UNSELECT_DEPT, postData)
  },
  // 取消选中人员
  unSelectOrgUsers(postData) {
    return http.post(URL.API_ORG_SANDBOX_UNSELECT_MEMBER, postData)
  },
  // 取消预选项
  rollbackOrgSandox(postData) {
    return http.post(URL.API_ORG_SANDBOX_ROLLBACK, postData)
  },
  // 提交预选项
  commitOrgSandBox(postData) {
    return http.post(URL.API_ORG_SANDBOX_COMMIT, postData)
  },
  // 清空所有已选学生
  unSelectOrgAll(postData) {
    return http.post(URL.API_ORG_SANDBOX_CLEAR_MEMBER, postData)
  },
  rollbackOrgSandBox(postData) {
    return http.post(URL.API_ORG_SANDBOX_ROLLBACK, postData)
  },
  searchOrgUsers(postData) {
    return http.post(URL.API_ORG_SANDBOX_SEARCH, postData)
  },
  // 模糊搜索部门列表
  searchOrgDepts(postData) {
    return http.get(URL.API_ORG_SEARCH_DEPTIDS, postData)
  },
  searchOrgMember(params) {
    return http.get(URL.API_SEARCH_ORG_MEMBER, params)
  }
  /** ******************** 机构通讯录 **********************/
}
